import React from "react";
import {
  DatePicker,
  FieldDropSide,
  ManageCensusLayout,
  MultiSelectDropdown,
  CsplTable as Table,
  Link,
  AddToolTip,
} from "../../../../components";

const columns = [
  {
    label: "Source Mapping",
    className: "column-source",
    columnName: "sourceMapping",
  },
  {
    label: "Contributions",
    className: "column-contributions",
    columnName: "contributions",
  },
  {
    label: "Earning",
    className: "column-earning",
    columnName: "earning",
  },
  {
    label: "Total",
    className: "column-total",
    columnName: "total",
  },
];
const data = [
  {
    sourceMapping: "Pre Tax",
    contributions: 2000,
    earning: 1000,
    total: 3000,
  },
  {
    sourceMapping: "After Tax",
    contributions: 2000,
    earning: 1000,
    total: 3000,
  },
  {
    sourceMapping: "Roth",
    contributions: 2000,
    earning: 1000,
    total: 3000,
  },
];
export const DistributionDetails = (props) => {
  return (
    <div className="history-distribution-transaction">
      <div className="header-content-rolloverin">Distributing Plan Details</div>
      <div className="sub-header-distribution-transaction">
        Previous plan and company details
      </div>
      <div className="cards-distribution-transaction">
        <div className="title-names-transaction">Plan name</div>
        <div className="response-names-transaction">some 401k</div>
      </div>
      <div className="cards-distribution-transaction">
        <div className="title-names-transaction">Plan type</div>
        <div className="response-names-transaction"> 401k</div>
      </div>
      <div className="cards-distribution-transaction">
        <div className="title-names-transaction">Company name</div>
        <div className="response-names-transaction">company 401k</div>
      </div>
      <div className="sub-header-distribution-transaction">
        Previous trustee / Custodian details
      </div>
      <div className="cards-distribution-transaction">
        <div className="title-names-transaction">Trustee / Custodian name</div>
        <div className="response-names-transaction">someone</div>
      </div>
      <div className="sub-header-distribution-transaction">Rollover Amount</div>
      <div className="cards-distribution-transaction">
        <div className="title-names-transaction">Enter rollover amount</div>
        <div className="response-names-transaction">$3200.00</div>
      </div>
      <div className="distribution-transaction-table">
        <Table className="distribution-transaction-history-table">
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {data.map((e, i) => {
              return (
                <Table.Tr key={i}>
                  <Table.Td className="cell-data-width">
                    {e.sourceMapping}
                  </Table.Td>
                  <Table.Td className="cell-data-width">
                    {e.contributions}
                  </Table.Td>
                  <Table.Td className="cell-data-width">{e.earning}</Table.Td>
                  <Table.Td className="cell-data-width">{e.total}</Table.Td>
                </Table.Tr>
              );
            })}
            <Table.Tr>
              <Table.Td className="w-75">Total rollover amount</Table.Td>
              <Table.Td className="w-25">$9000.00</Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </div>
      <div className="sub-header-distribution-transaction">
        Transaction details
      </div>
      <div className="cards-distribution-transaction">
        <div className="title-names-transaction">Payment mode</div>
        <div className="response-names-transaction">Cheque</div>
      </div>
      <div className="cards-distribution-transaction">
        <div className="title-names-transaction">Cheque number</div>
        <div className="response-names-transaction">3221234</div>
      </div>
      <div className="cards-distribution-transaction">
        <div className="title-names-transaction">Bank Account name</div>
        <div className="response-names-transaction">HDFC</div>
      </div>
      <div style={{ margin: "1rem 1rem" }}>
        <div className="response-names-transaction">Uploaded Documents</div>
      </div>
      <div className="distribution-card p-4" style={{ margin: "1rem 1rem" }}>
        <div className="d-flex flex-row justify-content-between ml-2">
          <div
            className="d-flex justify-content-start"
            style={{ height: "20px", maxWidth: "375px" }}
          >
            <i class="fas file-pdf-o distrbution-word"></i> &nbsp;
            {<AddToolTip name="doc 1" />}
          </div>

          <div
            className="d-flex justify-content-start"
            style={{ height: "20px", maxWidth: "375px" }}
          >
            <i class="fas file-pdf-o distrbution-word"></i> &nbsp;
            <AddToolTip name="doc 2" />
          </div>
          <div className="col-1"></div>
        </div>
      </div>
    </div>
  );
};
